import { useEffect, useState } from "react";
import PopUp from "../../../components/PopUp/PopUp";
import { getMarketingCampaignSendStatus } from "../../../api/marketingCampaigns.api";
// Ya no hace falta importar useRef ni react-email-editor

const POLL_INTERVAL_MS = 3000;

const SKIPPED_LABELS = {
  optedOut: "no aceptan comunicaciones",
  invalidEmail: "con email no válido",
  duplicated: "con email repetido",
  alreadySent: "ya la recibieron en el envío interrumpido",
  notFound: "no encontrados",
};

function SendStatus({ send }) {
  const processed = send.sent + send.failed;
  const skipped = Object.keys(SKIPPED_LABELS)
    .filter((key) => send.skipped?.[key] > 0)
    .map((key) => `${send.skipped[key]} ${SKIPPED_LABELS[key]}`);

  return (
    <div style={{ padding: "10px 20px" }}>
      {send.status === "processing" && (
        <p>
          <strong>
            Envío en curso: {processed} de {send.total} contactos.
          </strong>{" "}
          Puedes cerrar esta ventana, el envío continúa en el servidor.
        </p>
      )}
      {send.status === "completed" && (
        <p>
          <strong>
            Envío finalizado: {send.sent} de {send.total} correos enviados.
          </strong>
        </p>
      )}
      {send.status === "interrupted" && (
        <p>
          <strong>
            El envío se ha interrumpido: {send.sent} de {send.total} correos
            enviados.
          </strong>{" "}
          Cierra esta ventana y vuelve a enviar la campaña para continuar: los
          contactos que ya la han recibido no la recibirán de nuevo.
        </p>
      )}
      {send.failed > 0 && <p>Correos con error: {send.failed}.</p>}
      {skipped.length > 0 && <p>Contactos excluidos: {skipped.join(", ")}.</p>}
    </div>
  );
}

export function CampaignSendEmailPopUp({
  handleOpenSendMarketingCampaignEmail,
  selectedMarketingCampaign,
  contactsToSend,
  sendMarketingCampaign,
  user,
}) {
  const [submitting, setSubmitting] = useState(false);
  const [send, setSend] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  // Mientras el envío está en curso se consulta su progreso al servidor
  useEffect(() => {
    if (!send || send.status !== "processing") return;

    const timer = setTimeout(async () => {
      try {
        const res = await getMarketingCampaignSendStatus(send._id);
        setSend(res.send);
      } catch (error) {
        setSend((prev) => ({ ...prev })); // Reintenta en el siguiente intervalo
      }
    }, POLL_INTERVAL_MS);

    return () => clearTimeout(timer);
  }, [send]);

  const handleSendEmails = async () => {
    if (submitting) return;

    // El servidor resuelve los datos de cada contacto a partir de su _id
    const payload = {
      consultant: user,
      contacts: contactsToSend.map((contact) => ({ _id: contact._id })),
      subject: document.getElementById("subject").value,
      campaign: { _id: selectedMarketingCampaign[0]?._id },
      htmlBody: selectedMarketingCampaign[0]?.htmlBody, // 👈 ¡Directo de la BD!
    };

    setSubmitting(true);
    setErrorMessage("");

    try {
      const sendCampaign = await sendMarketingCampaign(payload);
      setSend(sendCampaign.send);
    } catch (error) {
      const data = error.response?.data;
      // Si ya había un envío en curso de esta campaña, se muestra su progreso
      if (data?.send) setSend(data.send);
      setErrorMessage(data?.message || "Hubo un error al enviar la campaña");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <PopUp
      handlePopUp={handleOpenSendMarketingCampaignEmail}
      height="95%"
      width="60%"
      title="Vista previa del correo"
      buttons={
        send ? (
          <button
            className="buttonForm"
            onClick={handleOpenSendMarketingCampaignEmail}
          >
            Cerrar
          </button>
        ) : (
          <>
            <button
              className="buttonFormCancel"
              onClick={handleOpenSendMarketingCampaignEmail}
            >
              Cancelar
            </button>
            <button
              className={
                submitting ? "buttonForm buttonForm--disabled" : "buttonForm"
              }
              onClick={handleSendEmails}
              disabled={submitting}
            >
              {submitting ? "Iniciando envío..." : "Enviar Campaña"}
            </button>
          </>
        )
      }
      fixedButtons={true}
    >
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        {/* Asunto */}
        <div style={{ display: "flex", padding: "10px 20px" }}>
          <h5 style={{ marginRight: 12 }}>Asunto:</h5>
          <input
            id="subject"
            type="text"
            defaultValue={selectedMarketingCampaign[0]?.title}
            style={{ flexGrow: 1 }}
            disabled={submitting || send !== null}
          />
        </div>

        {errorMessage && (
          <p style={{ padding: "0 20px", color: "red" }}>{errorMessage}</p>
        )}
        {send && <SendStatus send={send} />}

        <div
          style={{ flexGrow: 1, borderTop: "1px solid #ccc", padding: "10px" }}
        >
          <iframe
            srcDoc={selectedMarketingCampaign[0]?.htmlBody}
            style={{
              width: "100%",
              height: "60vh",
              border: "1px solid #eee",
              borderRadius: "8px",
            }}
            title="Previsualización de email"
          />
        </div>
      </div>
    </PopUp>
  );
}
